// Scales for the piano roll — a listening/drawing aid, never on the wire
// (the room has no key). Intervals are semitones above the root.

export const SCALES: ReadonlyArray<{ id: string; label: string; intervals: readonly number[] }> = [
  { id: "major", label: "Major", intervals: [0, 2, 4, 5, 7, 9, 11] },
  { id: "minor", label: "Minor", intervals: [0, 2, 3, 5, 7, 8, 10] },
  { id: "dorian", label: "Dorian", intervals: [0, 2, 3, 5, 7, 9, 10] },
  { id: "mixolydian", label: "Mixolydian", intervals: [0, 2, 4, 5, 7, 9, 10] },
  { id: "harmonic-minor", label: "Harmonic minor", intervals: [0, 2, 3, 5, 7, 8, 11] },
  { id: "pent-major", label: "Pentatonic major", intervals: [0, 2, 4, 7, 9] },
  { id: "pent-minor", label: "Pentatonic minor", intervals: [0, 3, 5, 7, 10] },
  { id: "blues", label: "Blues", intervals: [0, 3, 5, 6, 7, 10] },
];

export const ROOTS = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"] as const;

export function scaleById(id: string | undefined) {
  return SCALES.find((s) => s.id === id) ?? null;
}

/** Whether a pitch is a scale degree of (root, intervals). */
export function inScale(pitch: number, root: number, intervals: readonly number[]): boolean {
  const degree = (((pitch - root) % 12) + 12) % 12;
  return intervals.includes(degree);
}

/**
 * The nearest scale pitch to `pitch`: ties go DOWN (a raised note pulled
 * back to the degree below reads as the intended note more often than the
 * one above), and the result stays in 0–127.
 */
export function nearestInScale(pitch: number, root: number, intervals: readonly number[]): number {
  if (inScale(pitch, root, intervals)) return pitch;
  for (let d = 1; d <= 6; d++) {
    if (pitch - d >= 0 && inScale(pitch - d, root, intervals)) return pitch - d;
    if (pitch + d <= 127 && inScale(pitch + d, root, intervals)) return pitch + d;
  }
  return pitch;
}
